import { useEffect } from "react";
import { getAppVersion } from "../services/dataService";
import { useSnackbar } from "notistack";
import { Button } from "@mui/material";

const INITIAL_DELAY = 20_000; // 20 seconds
const POLLING_INTERVAL = 300_000; // 5 minutes

export const useVersionCheck = () => {
  const { enqueueSnackbar } = useSnackbar();
  const frontendVersion = import.meta.env.VITE_APP_VERSION;

  useEffect(() => {
    let intervalId = null;

    const checkVersion = async () => {
      try {
        const backendData = await getAppVersion();
        if (
          backendData &&
          backendData.version &&
          backendData.version !== frontendVersion
        ) {
          enqueueSnackbar(
            "Es gibt eine neue Version der Anwendung. Bitte speichern Sie Änderungen und laden die Seite neu.",
            {
              key: "version-update_snackbar",
              variant: "info",
              persist: true,
              preventDuplicate: true,
              action: (key) => (
                <Button
                  size="small"
                  onClick={() => window.location.reload()}
                  color={"primaryContrast"}
                >
                  Aktualisieren
                </Button>
              ),
            }
          );
          // Once the notification is shown, we can stop polling.
          if (intervalId) clearInterval(intervalId);
        }
      } catch (error) {
        console.error("Version check failed:", error);
        // Optional: decide if you want to stop polling on error
      }
    };

    // check after the initial delay
    let timeoutId = setTimeout(checkVersion, INITIAL_DELAY);
    intervalId = setInterval(checkVersion, POLLING_INTERVAL);

    // Cleanup on unmount
    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, [frontendVersion, enqueueSnackbar]);

  return frontendVersion;
};
